module.exports = __webpack_public_path__ + "static/so-2-sq-9dc72fbf28505cf2491aeb38499f3599.png";